import React, { useEffect,useContext } from "react";
import Context from './context';
import { useForm, reset   } from 'react-hook-form';
import config_servizi from "./_helpers/config_servizi";

import FormContatti from "./form_contatti";

export default function ContactUs(user) {
	
	 const  context = useContext(Context)
	 const { register, handleSubmit, formState: { errors }   } = useForm();
   

		 var traduzione = context.traduzione.translate.contact_us
     
    useEffect(() => {
      console.log("iframe",config_servizi[window.location.hostname].iframes,context.linguaAttuale)
    }, [context.linguaAttuale]);

	return (  <section className="contact-us" id="contactUsBlock">
      <div className="center">
        <div className="contact-us_wrap">
          <div className="contact-us_title title">
            {traduzione.altre_domande}          </div>
          <div className="contact-us_subtitle subtitle">
             {traduzione.desc_domande}           </div>
          <div className="contact-us_form-container">
            <div className="contact-us_form-wrap">
              <div className="contact-us_phone-block phone-block">
                <div className="phone-block_wrapp">
                 
                </div>
              </div>
              <div className="iframe_container">
              {config_servizi[window.location.hostname].iframes && (
                <div dangerouslySetInnerHTML={{__html: config_servizi[window.location.hostname].iframes[context.linguaAttuale.split('-')[0].toLowerCase()]}}></div>
              )}

              {!config_servizi[window.location.hostname].iframes && (
                <FormContatti/>
              )}
                  
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </section> )


}
